export default __webpack_public_path__ + "static/media/IconUser.506c0de7.svg";